import React from 'react';

const RecordIcon: React.FC = () => {
  return (
    <svg
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 2.27344C8.13261 2.27344 8.25979 2.32612 8.35355 2.41988C8.44732 2.51365 8.5 2.64083 8.5 2.77344V4.87344L11.1065 3.04844C11.144 3.02217 11.188 3.00669 11.2336 3.00369C11.2793 3.00069 11.3249 3.01029 11.3655 3.03143C11.4061 3.05258 11.4401 3.08447 11.4638 3.12361C11.4875 3.16276 11.5001 3.20767 11.5 3.25344V9.29344C11.5001 9.33921 11.4875 9.38411 11.4638 9.42326C11.4401 9.46241 11.4061 9.49429 11.3655 9.51544C11.3249 9.53659 11.2793 9.54619 11.2336 9.54319C11.188 9.54019 11.144 9.52471 11.1065 9.49844L8.5 7.67344V9.77344C8.5 9.90605 8.44732 10.0332 8.35355 10.127C8.25979 10.2208 8.13261 10.2734 8 10.2734H1C0.867392 10.2734 0.740215 10.2208 0.646447 10.127C0.552678 10.0332 0.5 9.90605 0.5 9.77344V2.77344C0.5 2.64083 0.552678 2.51365 0.646447 2.41988C0.740215 2.32612 0.867392 2.27344 1 2.27344H8ZM3.7 4.68794C3.65389 4.68793 3.6092 4.70385 3.57348 4.73301C3.53777 4.76216 3.51322 4.80276 3.504 4.84794L3.5 4.88744V7.65844C3.5 7.69083 3.50786 7.72273 3.52291 7.75141C3.53796 7.78009 3.55975 7.80468 3.58641 7.82308C3.61307 7.84147 3.6438 7.85312 3.67595 7.85701C3.7081 7.86091 3.74072 7.85694 3.771 7.84544L3.8075 7.82744L5.985 6.44144C6.01041 6.42518 6.03181 6.40339 6.0476 6.3777C6.0634 6.352 6.07318 6.32306 6.07621 6.29306C6.07924 6.26305 6.07544 6.23274 6.0651 6.20441C6.05476 6.17607 6.03815 6.15044 6.0165 6.12944L5.985 6.10444L3.8075 4.71844C3.77524 4.69844 3.73795 4.68803 3.7 4.68844V4.68794Z'
        fill='#EF4444'
      />
    </svg>
  );
};

export default RecordIcon;
